export const LOGIN_CLIENT_ID = 'login';
//# sourceMappingURL=keycloak.js.map